export default __webpack_public_path__ + "static/media/hiphop.5a806d12.png";